var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "manage-event-detail-container" }, [
    _c(
      "div",
      {
        staticClass: "overlay",
        class: { isLoading: _vm.getIsLoading, noDisplay: !_vm.getIsLoading }
      },
      [
        _c(
          "div",
          { staticClass: "spinner-align" },
          [
            _c("Icon", {
              staticClass: "icon-size",
              attrs: { name: "spinner", scale: "5", pulse: "" }
            })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    !_vm.getIsLoading
      ? _c(
          "div",
          { staticClass: "event-detail-wrapper margin-side modal-padding" },
          [
            _c("div", { staticClass: "event-detail-header row" }, [
              _c("div", { staticClass: "col-md-6 noPaddingLeft" }, [
                _c("span", { staticClass: "event-details" }, [
                  _vm._v(_vm._s(_vm.event.eventName))
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6 noPaddingRight align-right-item" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-close-img",
                      on: {
                        click: function($event) {
                          _vm.back()
                        }
                      }
                    },
                    [_c("div", { staticClass: "icon-close" })]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-detail-body row margin-top-24px" },
              [
                _c(
                  "div",
                  { staticClass: "col-md-6 event-information noPaddingLeft" },
                  [_vm._v("\n          Event information\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-md-6 event-information noPaddingRight align-right-item"
                  },
                  [
                    _c("div", { staticClass: "staffing-edit-btn" }, [
                      _vm.editing
                        ? _c(
                            "button",
                            {
                              staticClass: "ap-btn secondary",
                              on: { click: _vm.onSave }
                            },
                            [_vm._v("Save")]
                          )
                        : _c(
                            "button",
                            {
                              staticClass: "ap-btn secondary",
                              on: { click: _vm.onEdit }
                            },
                            [_vm._v("Edit")]
                          )
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-detail-body row margin-top-16px" },
              [
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Event Name")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.event.eventName,
                              expression: "event.eventName"
                            }
                          ],
                          domProps: { value: _vm.event.eventName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.event,
                                "eventName",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", [_vm._v(_vm._s(_vm.event.eventName))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [_vm._v("Date")]),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "event-info" },
                    [
                      _vm.editing
                        ? _c("date-picker", {
                            attrs: {
                              value: _vm.event.prefDate,
                              format: "MMMM d, yyyy"
                            }
                          })
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormatMMMM")(_vm.event.prefDate)
                              )
                            )
                          ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Client")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm._v(_vm._s(_vm.event.clientName))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Custom Event Notes")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.event.customEventNote,
                              expression: "event.customEventNote"
                            }
                          ],
                          domProps: { value: _vm.event.customEventNote },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.event,
                                "customEventNote",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", [_vm._v(_vm._s(_vm.event.customEventNote))])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-detail-body row margin-top-16px" },
              [
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Address")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.event.fullAddress,
                              expression: "event.fullAddress"
                            }
                          ],
                          domProps: { value: _vm.event.fullAddress },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.event,
                                "fullAddress",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", [_vm._v(_vm._s(_vm.event.fullAddress))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Time and Duration")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info show-dropdown" }, [
                    _c("table", [
                      _c("tr", [
                        _c("td", [_vm._v("Start: ")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm.editing
                            ? _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.startTime,
                                      expression: "event.startTime"
                                    }
                                  ],
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.event,
                                        "startTime",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                _vm._l(_vm.listTime, function(time) {
                                  return _c(
                                    "option",
                                    { domProps: { value: time.name } },
                                    [_vm._v(_vm._s(time.name))]
                                  )
                                })
                              )
                            : _c("span", [_vm._v(_vm._s(_vm.event.startTime))])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("End: ")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm.editing
                            ? _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.endTime,
                                      expression: "event.endTime"
                                    }
                                  ],
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.event,
                                        "endTime",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                _vm._l(_vm.listTime, function(time) {
                                  return _c(
                                    "option",
                                    { domProps: { value: time.name } },
                                    [_vm._v(_vm._s(time.name))]
                                  )
                                })
                              )
                            : _c("span", [_vm._v(_vm._s(_vm.event.endTime))])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("Duration: ")]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _vm.editing
                              ? [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.event.duration,
                                          expression: "event.duration"
                                        }
                                      ],
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.event,
                                            "duration",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    _vm._l(24, function(n) {
                                      return _c(
                                        "option",
                                        { domProps: { value: n } },
                                        [_vm._v(_vm._s(n))]
                                      )
                                    })
                                  )
                                ]
                              : _c("span", [
                                  _vm._v(_vm._s(_vm.event.duration))
                                ]),
                            _vm._v("\n                  HR\n                ")
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("Time zone: ")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.event.timeZone) +
                              "\n                "
                          )
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Program")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm._v(_vm._s(_vm.event.eventName))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("On Site Instructions")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.event.onsiteInstruction,
                              expression: "event.onsiteInstruction"
                            }
                          ],
                          domProps: { value: _vm.event.onsiteInstruction },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.event,
                                "onsiteInstruction",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", [
                          _vm._v(_vm._s(_vm.event.onsiteInstruction))
                        ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-detail-body row margin-top-16px" },
              [
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Building/Suite")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.event.building,
                              expression: "event.building"
                            }
                          ],
                          domProps: { value: _vm.event.building },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.event,
                                "building",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", [_vm._v(_vm._s(_vm.event.building))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("ADURO Arrival Time")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.event.aduroArrivalTime,
                                expression: "event.aduroArrivalTime"
                              }
                            ],
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.event,
                                  "aduroArrivalTime",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          _vm._l(_vm.listTime, function(time) {
                            return _c(
                              "option",
                              { domProps: { value: time.name } },
                              [_vm._v(_vm._s(time.name))]
                            )
                          })
                        )
                      : _c("span", [_vm._v(_vm._s(_vm.event.aduroArrivalTime))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("On Site Contact")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm._v(_vm._s(_vm.event.contactName))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Parking Instructions")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.event.parkingInformation,
                              expression: "event.parkingInformation"
                            }
                          ],
                          domProps: { value: _vm.event.parkingInformation },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.event,
                                "parkingInformation",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", [
                          _vm._v(_vm._s(_vm.event.parkingInformation))
                        ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-detail-body row margin-top-16px" },
              [
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Location")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.event.eventLocation,
                              expression: "event.eventLocation"
                            }
                          ],
                          domProps: { value: _vm.event.eventLocation },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.event,
                                "eventLocation",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", [_vm._v(_vm._s(_vm.event.eventLocation))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Participation")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _c("div", { staticClass: "oval oval-red" }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.event.numParticipant) +
                          "/" +
                          _vm._s(_vm.event.maxParticipant) +
                          " participants"
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Add-ons")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "event-info" },
                    _vm._l(_vm.addOns, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "add-on-wrapper" },
                        [
                          _c("div", { staticClass: "event-add-on mb-1" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.value,
                                  expression: "item.value"
                                }
                              ],
                              attrs: { type: "checkbox", id: item.key },
                              domProps: {
                                checked: Array.isArray(item.value)
                                  ? _vm._i(item.value, null) > -1
                                  : item.value
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = item.value,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            item,
                                            "value",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            item,
                                            "value",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(item, "value", $$c)
                                    }
                                  },
                                  function($event) {
                                    _vm.checkboxToggle(item.key, item.value)
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: item.key } }, [
                              _vm._v("Toggle")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "text" }, [
                            _vm._v(_vm._s(item.text))
                          ])
                        ]
                      )
                    })
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("div", { staticClass: "add-on-wrapper" }, [
                    _c("div", { staticClass: "event-add-on" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.event.isLive,
                            expression: "event.isLive"
                          }
                        ],
                        attrs: { type: "checkbox", id: "is-live" },
                        domProps: {
                          checked: Array.isArray(_vm.event.isLive)
                            ? _vm._i(_vm.event.isLive, null) > -1
                            : _vm.event.isLive
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.event.isLive,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.event,
                                      "isLive",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.event,
                                      "isLive",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.event, "isLive", $$c)
                              }
                            },
                            function($event) {
                              _vm.updateIsLiveEvent("LIVE")
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "is-live" } }, [
                        _vm._v("Toggle")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text",
                        class: { "online-text": _vm.event.isLive }
                      },
                      [_vm._v("Live")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm.event.contactName
              ? _c("div", { staticClass: "event-detail-body row" }, [
                  _c("div", { staticClass: "col-md-4 margin-top-16px" }, [
                    _c("div", { staticClass: "wrapper-text" }, [
                      _c("div", { staticClass: "event-info" }, [
                        _vm._v(_vm._s(_vm.event.contactName))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "event-info" }, [
                        _vm._v(_vm._s(_vm.event.email))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "event-info" }, [
                        _vm._v(_vm._s(_vm.event.phone))
                      ])
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "event-detail-body row" }, [
              _c(
                "div",
                { staticClass: "col-md-6 event-information noPaddingLeft" },
                [
                  _c("span", [_vm._v("Email")]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "view-history-text",
                      on: { click: _vm.viewAllMailHistories }
                    },
                    [_vm._v("View History")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-md-6 noPaddingRight noPaddingLeft align-right-item"
                },
                [
                  _c("div", { staticClass: "staffing-edit-btn" }, [
                    _c(
                      "button",
                      {
                        staticClass: "ap-btn secondary",
                        on: { click: _vm.manageEmail }
                      },
                      [_vm._v("Email Client")]
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-detail-body row margin-top-16px" },
              [
                _c(
                  "div",
                  { staticClass: "col-md-12 email-text noPaddingLeft" },
                  [
                    _vm._v(
                      "\n          Last Email Sent: " +
                        _vm._s(
                          _vm._f("templateName")(_vm.event.emailReminderStatus)
                        ) +
                        "\n        "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "event-detail-body row" }, [
              _c(
                "div",
                { staticClass: "col-md-9 event-information noPaddingLeft" },
                [_vm._v("\n          Staff & Slot Management\n        ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-md-3 noPaddingRight noPaddingLeft align-right-item"
                },
                [
                  _c("div", { staticClass: "staffing-edit-btn" }, [
                    _c(
                      "button",
                      {
                        staticClass: "ap-btn secondary",
                        on: { click: _vm.manageEventStaffingDetail }
                      },
                      [_vm._v("Manage")]
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-detail-body row margin-top-16px" },
              [
                _c("div", { staticClass: "col-md-12 noPaddingLeft" }, [
                  _c(
                    "div",
                    { staticClass: "wrapper-text-number display-inline" },
                    [
                      _c("div", { staticClass: "oval oval-red" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "number" }, [
                        _vm._v(
                          _vm._s(_vm.event.numStaffLead) +
                            "/" +
                            _vm._s(_vm.event.maxStaffLead) +
                            " Leads"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wrapper-text-number display-inline" },
                    [
                      _c("div", {
                        staticClass: "oval oval-red margin-left-8px"
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "number" }, [
                        _vm._v(
                          _vm._s(_vm.event.numStaffConcierge) +
                            "/" +
                            _vm._s(_vm.event.maxStaffConcierge) +
                            " Concierge"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wrapper-text-number display-inline" },
                    [
                      _c("div", {
                        staticClass: "oval oval-red margin-left-8px"
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "number" }, [
                        _vm._v(
                          _vm._s(_vm.event.numStaffScreener) +
                            "/" +
                            _vm._s(_vm.event.maxStaffScreener) +
                            " Screeners"
                        )
                      ])
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _c("div", { staticClass: "event-detail-body row" }, [
              _c(
                "div",
                { staticClass: "col-md-6 event-information noPaddingLeft" },
                [_vm._v("\n          Shipping\n        ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-md-6 event-information noPaddingRight noPaddingLeft align-right-item"
                },
                [
                  _c("div", { staticClass: "staffing-edit-btn" }, [
                    _c(
                      "button",
                      {
                        staticClass: "ap-btn secondary",
                        on: {
                          click: function($event) {
                            _vm.generatePackingSlipBtn()
                          }
                        }
                      },
                      [_vm._v("Generate Packing Slip")]
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-detail-body row margin-top-16px" },
              [
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Address")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.event.shippingAddress,
                              expression: "event.shippingAddress"
                            }
                          ],
                          domProps: { value: _vm.event.shippingAddress },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.event,
                                "shippingAddress",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", [_vm._v(_vm._s(_vm.event.shippingAddress))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Supplies Tracking")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "supplies-tracking-status margin-bottom-10px"
                    },
                    [
                      _c("div", {
                        staticClass: "oval",
                        class:
                          _vm.shippingStatus !== "" ? "oval-green" : "oval-red"
                      }),
                      _vm._v(" "),
                      _c("span", {}, [
                        _vm._v(
                          _vm._s(
                            _vm.trackingNumber !== ""
                              ? _vm.shippingStatus !== ""
                                ? _vm.shippingStatus
                                : "Shipping info not entered"
                              : "Shipping info not entered"
                          )
                        )
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Tracking Number")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.event.trackingNumber,
                              expression: "event.trackingNumber"
                            }
                          ],
                          domProps: { value: _vm.event.trackingNumber },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.event,
                                "trackingNumber",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", [_vm._v(_vm._s(_vm.trackingNumber))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Shipping Note")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.event.shippingNote,
                              expression: "event.shippingNote"
                            }
                          ],
                          domProps: { value: _vm.event.shippingNote },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.event,
                                "shippingNote",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", [_vm._v(_vm._s(_vm.event.shippingNote))])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _c("div", { staticClass: "series-related-events-section" }, [
              _c(
                "div",
                { staticClass: "related-events-top event-detail-body row" },
                [
                  _c(
                    "div",
                    { staticClass: "col-md-6 event-information noPaddingLeft" },
                    [
                      _vm._v("\n            Related Events\n            "),
                      _c("span", [
                        _vm._v(
                          "(" + _vm._s(_vm.event.relatedEvents.length) + ")"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-6 noPaddingRight noPaddingLeft align-right-item"
                    },
                    [
                      _c("div", { staticClass: "staffing-edit-btn" }, [
                        _vm.event.relatedEvents.length == 0
                          ? _c(
                              "button",
                              {
                                staticClass: "btn-add-related ap-btn secondary",
                                on: { click: _vm.manageRelatedEvent }
                              },
                              [_vm._v("Create Related Events")]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "btn-add-related ap-btn secondary",
                                on: { click: _vm.manageRelatedEvent }
                              },
                              [_vm._v("Manage Related Events")]
                            )
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "related-event-container event-detail-body row"
                },
                _vm._l(_vm.event.relatedEvents, function(reEvent) {
                  return _c(
                    "div",
                    { staticClass: "col-md-3 margin-top-16px" },
                    [
                      _c("div", { staticClass: "related-event-item" }, [
                        _c(
                          "div",
                          {
                            staticClass: "event-name",
                            on: {
                              click: function($event) {
                                _vm.relatedEventItemClick(reEvent.id)
                              }
                            }
                          },
                          [_vm._v(_vm._s(reEvent.eventName))]
                        )
                      ])
                    ]
                  )
                })
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "event-detail-body row" }, [
      _c("div", { staticClass: "col-md-12 liner" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "event-detail-body row" }, [
      _c("div", { staticClass: "col-md-6 event-information noPaddingLeft" }, [
        _vm._v("\n          On Site Contacts\n        ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "event-detail-body row" }, [
      _c("div", { staticClass: "col-md-12 liner" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "event-detail-body row" }, [
      _c("div", { staticClass: "col-md-12 liner" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "event-detail-body row" }, [
      _c("div", { staticClass: "col-md-12 liner" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "event-detail-body row" }, [
      _c("div", { staticClass: "col-md-12 liner" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-13e919a1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13e919a1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/event/ManageEventDetail.vue
// module id = 1799
// module chunks = 1